import { googleClient } from '@service-initiation/shared-clients-google';
import { queryClient } from '@service-initiation/shared-utils-query-client';

import { type Address } from '../types/Address';
import { extractAddress } from './extractAddress';

export const placeIdToAddress = async (placeId: string) => {
  const places = (await googleClient).places;
  const sessionToken = (await googleClient).sessionToken;

  return await queryClient.fetchQuery({
    queryFn: async () => {
      return new Promise<Address>((resolve, reject) => {
        places.getDetails(
          {
            fields: ['address_components'],
            placeId,
            sessionToken: sessionToken,
          },
          (
            result: google.maps.places.PlaceResult | null,
            status: google.maps.places.PlacesServiceStatus
          ) => {
            if (
              status !== google.maps.places.PlacesServiceStatus.OK ||
              result?.address_components === undefined
            ) {
              reject(
                new Error(
                  `Failed to fetch address details for provided placeId: ${placeId}`
                )
              );
            } else {
              resolve(extractAddress(result.address_components));
            }
          }
        );
      });
    },
    queryKey: ['placeIdToAddress', placeId],
    retry: 2,
    staleTime: Infinity,
  });
};
